import {createI18n} from 'vue-i18n';

const localeModules = import.meta.glob('./locales/*/**/*.js', { eager: true });
const messages = {};

Object.entries(localeModules).forEach(([path, module]) => {
    const match = path.match(/\.\/locales\/([^/]+)\/(.+)\.js$/);
    if (!match) {
        return;
    }

    const [, locale, fileName] = match;
    const part = fileName.split('/').pop();

    if (!messages[locale]) {
        messages[locale] = {};
    }

    messages[locale][part] = {
        ...(messages[locale][part] ?? {}),
        ...((module && 'default' in module) ? module.default : module),
    };
});

const i18n = createI18n({
    legacy: true,
    globalInjection: true,
    locale: window.appConfig.user?.locale ?? 'ru',
    fallbackLocale: 'en',
    messages,
});

export default i18n;
